/**
 * The day and the night (ADR 0093): one cycle of 140 minutes, the same for
 * the whole world and computed from the clock alone, like the world events'
 * calendar. 140 minutes does not divide a day, so the night falls at another
 * hour each day and the player of the evening sees the morning too. Data, not
 * code (CLAUDE.md rule 4); the pure rules are in `rules/daylight.ts`.
 */
const MINUTE_MS = 60_000;
/** The cycle's four parts, in order from the epoch: dawn, day, dusk, night. */
export const DAYLIGHT = Object.freeze({
    /** The light coming back. */
    dawnMs: 6 * MINUTE_MS,
    /** Full light. */
    dayMs: 88 * MINUTE_MS,
    /** The light going. */
    duskMs: 6 * MINUTE_MS,
    /** Full night: the creatures of the night are out. */
    nightMs: 40 * MINUTE_MS,
});
export const DAYLIGHT_CYCLE_MS = DAYLIGHT.dawnMs + DAYLIGHT.dayMs + DAYLIGHT.duskMs + DAYLIGHT.nightMs;
//# sourceMappingURL=daylight.js.map